<template>
    <v-slide-y-transition>
        <div class="cash-sales-search">
            <v-row>
                <v-col cols="8">
                    <v-menu
                        v-model="picker1"
                        :close-on-content-click="false"
                        :nudge-right="32"
                        transition="scale-transition"
                        min-width="290"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="form.startDate"
                                :error-messages="form.$errors.startDate"
                                :label="$t('general.start_date')"
                                prepend-icon="fal fa-calendar"
                                clear-icon="fal fa-times"
                                clearable
                                readonly
                                v-on="on"
                                @blur="form.validate('startDate')"
                                @input="delete form.$errors.startDate"
                            />
                        </template>
                        <v-date-picker
                            v-model="form.startDate"
                            @input="picker1 = false; form.validate('startDate')"
                        />
                    </v-menu>
                </v-col>

                <v-col cols="4">
                    <v-text-field
                        v-model="form.startTime"
                        v-mask="'##:##:##'"
                        placeholder="hh:mm:ss"
                        :label="$t('general.time')"
                        :error-messages="form.$errors.startTime"
                        @blur="form.validate('startTime'); form.validate('endTime');"
                        @input="delete form.$errors.startTime"
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col class="py-0" cols="8">
                    <v-menu
                        v-model="picker2"
                        :close-on-content-click="false"
                        :nudge-right="32"
                        transition="scale-transition"
                        min-width="290"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="form.endDate"
                                :error-messages="form.$errors.endDate"
                                :label="$t('general.end_date')"
                                prepend-icon="fal fa-calendar"
                                clear-icon="fal fa-times"
                                clearable
                                readonly
                                v-on="on"
                                @blur="form.validate('endDate')"
                            />
                        </template>
                        <v-date-picker
                            v-model="form.endDate"
                            :min="form.startDate"
                            @input="picker2 = false; form.validate('endDate')"
                        />
                    </v-menu>
                </v-col>

                <v-col class="py-0" cols="4">
                    <v-text-field
                        v-model="form.endTime"
                        v-mask="'##:##:##'"
                        placeholder="hh:mm:ss"
                        :label="$t('general.time')"
                        :error-messages="form.$errors.endTime"
                        @blur="form.validate('endTime')"
                        @input="delete form.$errors.endTime"
                    />
                </v-col>
            </v-row>

            <div class="d-flex justify-center mt-4">
                <v-btn
                    color="primary"
                    outlined
                    @click="search"
                >
                    {{ $t('general.search') }}
                </v-btn>
            </div>
        </div>
    </v-slide-y-transition>
</template>

<script>
import _ from 'lodash';
import { required, helpers } from 'vuelidate/lib/validators';

export default {
    props: {
        filter: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            picker1: false,
            picker2: false,
            form: this.createForm(),
        };
    },

    validations() {
        return {
            form: {
                startDate: { required: required },
                startTime: {
                    required: required,
                    time: helpers.withParams(
                        { type: 'time' },
                        function(value) {
                            if(!value) return true

                            return moment(value, 'HH:mm:ss', true).isValid()
                        }
                    )
                },
                endDate: { required: required },
                endTime: {
                    required: required,
                    timeAfter: helpers.withParams(
                        { type: 'timeAfter' },
                        function(value) {
                            if(!value) return true

                            if(!moment(value, 'HH:mm:ss', true).isValid()) {
                                return false
                            }

                            if(!this.form.startDate || !this.form.startTime || !this.form.endDate) {
                                return false
                            }

                            return moment(`${this.form.endDate} ${value}`)
                                .isAfter(moment(`${this.form.startDate} ${this.form.startTime}`))
                        }
                    )
                },
            }
        }
    },

    watch: {
        filter(val) {
            this.form = this.createForm();
        }
    },

    methods: {
        createForm() {
            return new Form(this, 'form', {
                search: this.filter?.search || null,
                startDate: this.filter?.startDate ? moment(this.filter.startDate).format('YYYY-MM-DD') : null,
                startTime: this.filter?.startDate ? moment(this.filter.startDate).format('HH:mm:ss') : null,
                endDate: this.filter?.endDate ? moment(this.filter.endDate).format('YYYY-MM-DD') : null,
                endTime: this.filter?.endDate ? moment(this.filter.endDate).format('HH:mm:ss') : null,
            });
        },

        searchDebounce: _.debounce(function() {
            this.search();
        }, 500),

        search() {
            if(!this.form.validate()) return;

            const formData = this.form.toJson();

            this.$emit('update:filter', {
                search: formData.search,
                startDate: formData.startDate ? `${formData.startDate} ${formData.startTime || ''}` : null,
                endDate: formData.endDate ? `${formData.endDate} ${formData.endTime || ''}` : null,
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.cash-sales-search {
    padding: 16px;
    border-radius: 3px;
    background: #fafafa;
    border: 1px solid #cccccc;
}
</style>
